import { CardInfoAreaEntityMobile } from '@entities/mobile/cards';

import { BannerCardItemImageByVariant } from '@/shared/ui/item/item-image-by-variant/item-image-by-variant';

import styles from './header.module.scss';

export const FavoritesHeaderMobile = () => {
  return (
    <div className={styles['first-section']}>
      <CardInfoAreaEntityMobile
        variant={'red'}
        title={'Favorite'}
        iconSlot={
          <BannerCardItemImageByVariant
            className={styles.item}
            size={'90'}
            variant={'heart'}
          />
        }
        subtitle={'6541 items in the category'}
      />
    </div>
  );
};
